import { gql } from "lib/apolloClient";
import { pypElementRatingFragment } from "modules/CommonFragments";
import { iBPYPElementRatingFragment } from "CommonGraphql/IBPYPElementRating/IBPYPElementRatingFragments";

export const getClassProgressSummaryCsvExportQuery = gql`
  query getClassProgressSummaryCsvExport($courseId: ID!) {
    node(id: $courseId, type: COURSE) {
      id
      ... on Course {
        id
        classProgressSummaryCsvExport
      }
    }
  }
`;

export const getStudentsPypElementRatingsQuery = gql`
  query getStudentPypEvaluation(
    $studentIds: [ID!]
    $filtersForRecentMost: ibPYPElementRatingFilterForRecentMost
    $endDate: String
  ) {
    multiNode(ids: $studentIds, type: STUDENT) {
      id
      ... on Student {
        id
        ibPYPElementRatings(
          filtersForRecentMost: $filtersForRecentMost
          dataSet: MOST_RECENT
          endDate: $endDate
        ) {
          ...ratingItem
        }
      }
    }
  }
  ${pypElementRatingFragment.studentElementRatingSlim}
`;

export const getStudentsPypElementRatingHistoryQuery = gql`
  query getStudentPypEvaluation(
    $studentId: ID!
    $filtersForRatingHistory: ibPYPElementRatingFiltersForRatingHistory
    $endDate: String
    $curriculumProgramId: ID
  ) {
    node(id: $studentId, type: STUDENT) {
      id
      ... on Student {
        id
        ibPYPElementRatings(
          filtersForRatingHistory: $filtersForRatingHistory
          dataSet: RATING_HISTORY
          endDate: $endDate
          curriculumProgramId: $curriculumProgramId
        ) {
          ...ratingItem
        }
      }
    }
  }
  ${iBPYPElementRatingFragment.studentElementRatingHistory}
`;

export const getCourseUnitPlansBasicDetailsFeedQuery = gql`
  query getCourseUnitPlansBasicDetailsFeed($id: ID!) {
    node(id: $id, type: COURSE) {
      id
      ... on Course {
        id
        flatUnitPlans {
          edges {
            node {
              id
              title {
                id
                value
              }
            }
          }
        }
      }
    }
  }
`;
